import { ConfigProvider, Flex, Segmented, theme, Typography } from 'antd'
import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useSetTheme, useThemePreference } from '../lib/themeController'
import type { ThemePreference } from '../lib/themeTokens'

/**
 * Light / dark / system toggle shown inside the header user dropdown. Clicks
 * are stopped from reaching the menu item so choosing a theme does not close
 * the dropdown, and the result is visible immediately.
 */
export function ThemeSwitcher() {
  const { t } = useTranslation()
  const preference = useThemePreference()
  const setTheme = useSetTheme()
  const { token } = theme.useToken()

  return (
    <Flex
      vertical
      gap={4}
      style={{ minWidth: 260 }}
      onClick={(event) => event.stopPropagation()}
    >
      <Typography.Text type="secondary">
        {t('frontend:theme.label')}
      </Typography.Text>
      {/* The default track is the (transparent) layout colour, which hides the
          selected option against the dropdown surface. */}
      <ConfigProvider
        theme={{
          components: { Segmented: { trackBg: token.colorFillSecondary } },
        }}
      >
        <Segmented
          block
          size="small"
          value={preference}
          aria-label={t('frontend:theme.label')}
          onChange={(value) => setTheme(value as ThemePreference)}
          options={[
            {
              value: 'light',
              icon: <SunOutlined />,
              label: t('frontend:theme.light'),
            },
            {
              value: 'dark',
              icon: <MoonOutlined />,
              label: t('frontend:theme.dark'),
            },
            {
              value: 'system',
              icon: <DesktopOutlined />,
              label: t('frontend:theme.system'),
            },
          ]}
        />
      </ConfigProvider>
    </Flex>
  )
}
